import React from 'react'
import Header from '../../components/header/Header'

const Download = () => {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default Download